import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';

import { IntelligenceAnalyticsHttpClient } from './intelligence-analytics-http-client';
import { IntelligenceAnalyticsActions } from './intelligence-analytics.store';

@Injectable({ providedIn: 'root' })
export class IntelligenceAnalyticsEffects {
  private readonly http = inject(IntelligenceAnalyticsHttpClient);
  private readonly actions = inject(Actions);

  private track$ = createEffect(() =>
    this.actions.pipe(
      ofType(IntelligenceAnalyticsActions.track),
      mergeMap(({ payload: { event, data } }) =>
        this.http.track(event, data).pipe(
          map(() => IntelligenceAnalyticsActions.trackSuccess({ payload: { event } })),
          catchError(error =>
            of(IntelligenceAnalyticsActions.trackFailed({ payload: { event, error } })),
          ),
        ),
      ),
    ),
  );
}
